/* eslint import/newline-after-import: "off" */
import {Component} from 'san';
import styles from './style/index.module.less';
import '../../assets/svg/voice.svg';
import '../../assets/svg/pause.svg';

export default class TtsBtn extends Component {
    static template = require('./index.html');

    initData() {
        return {
            styles,
            playUse: '<use xlink:href="#voice"/>',
            pauseUse: '<use xlink:href="#pause"/>'
        };
    }
    attached() {
    }
    clickTts() {
        this.storeDispatch('tts:click');
    }
};
